import React, { Fragment, useState, useEffect } from 'react';
import { Field, FormSection } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ExamTypeSelector from '../../../../shared/components/ExamTypeSelector';
import { employeeListByFilterWithAccessQuery } from '../../../../shared/queries/Employee';
import Select from '../../../../shared/components/form/Select';
import GraphQL from '../../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../../shared/components/ShowNotification';
import SelectVirtualized from '../../../../shared/components/form/SelectVirtualized';
import DateField from '../../../../shared/components/form/DateField';
import renderField from '../../../../shared/components/form/RenderField';
import { evaluationWayListByFilter } from '../../../../shared/queries/EvaluationWay';

const ExamFields = (props) => {
  const {
    t,
    showLoading,
    hideLoading,
    change,
    editable,
    loadCourseSteps,
    listOfCourseStep,
    recipients,
    subjects,
    loadSubjects,
    evaluationTypes,
    cycles,
    loadCourseStepsChangeHandler,
  } = props;
  const [employees, setEmployees] = useState([]);
  const [evaluationWayList, setEvaluationWayList] = useState([]);

  const loadEmployees = () => {
    const filter = {
      id: 0,
      usuarioChatInterno: false,
      ativo: true,
      filterByStatus: true,
      pedagogicAdm: false,
      updaterId: 0,
      usuarioChat: false,
      active: true,
    };
    const query = employeeListByFilterWithAccessQuery(filter);
    GraphQL(query, {})
      .then((res) => {
        res.employeeListByFilterWithAccess =
          res.employeeListByFilterWithAccess.map((employee) => ({
            ...employee,
            value: employee.id,
            label: employee.name,
          }));
        setEmployees(res.employeeListByFilterWithAccess);
        if (res.employeeListByFilterWithAccess.length === 1) {
          const teacher = {
            ...res.employeeListByFilterWithAccess[0],
            value: res.employeeListByFilterWithAccess[0].id,
            label: res.employeeListByFilterWithAccess[0].name,
          };
          change('examHeader.teacher', teacher);
          loadSubjects(res.employeeListByFilterWithAccess[0].id);
        }
      })
      .catch((error) => {
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadEvaluationWay = () => {
    showLoading();
    const filter = { id: 0, active: true, filterByStatus: true, updaterId: 0 };
    const query = evaluationWayListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        setEvaluationWayList(res.evaluationWayListByFilter);
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
      });
  };

  const onEmployeeChangeHandler = (value) => {
    if (value) {
      loadSubjects(value.value);
    }
  };

  const onRecipientChange = (values) => {
    if (values) {
      change('recipients', values);
    } else {
      change('recipients', []);
    }
  };

  const onApplicationDateChange = (selectedDate) => {
    change('dueDate', selectedDate);
  };

  useEffect(() => {
    loadCourseSteps(0);
    loadEvaluationWay();
    loadEmployees();
  }, []);

  return (
    <Fragment>
      <FormSection name="examHeader" className="form__section">
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.course')}</span>
          <div className="form__form-group-field">
            <Field
              name="courseStep"
              component={SelectVirtualized}
              options={listOfCourseStep}
              clearable={false}
              placeholder={t('communication.placeholders.course')}
              onChange={loadCourseStepsChangeHandler}
            />
          </div>
        </div>
      </FormSection>
      <div className="form__form-group">
        <span className="form__form-group-label">{t('general.evaluated')}</span>
        <div className="form__form-group-field">
          <Field
            name="recipients"
            type="text"
            component={SelectVirtualized}
            isMulti
            closeMenuOnSelect={false}
            options={recipients}
            placeholder={t('communication.placeholders.recipients')}
            onChange={onRecipientChange}
            isDisabled={!editable}
          />
        </div>
      </div>
      <FormSection name="examHeader" className="form__section">
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('communication.teacher')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="teacher"
                type="text"
                component={Select}
                isDisabled={!employees || !editable}
                options={employees}
                placeholder={t('communication.placeholders.teacher')}
                onChange={onEmployeeChangeHandler}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('communication.subject')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="subject"
                type="text"
                component={Select}
                isDisabled={!subjects || !editable}
                options={subjects}
                placeholder={t('communication.placeholders.subject')}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('communication.cycle')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="cycle"
                type="text"
                component={Select}
                isDisabled={!cycles || !editable}
                options={cycles}
                placeholder={t('communication.placeholders.cycle')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('communication.due-date-EXAM')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="dueDate"
                component={DateField}
                placeholder={t('communication.placeholders.due-date-EXAM')}
                disabled={!editable}
                onChange={(value) => onApplicationDateChange(value)}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.exam-type')}
          </span>
          <div className="form__form-group-field">
            <Field name="examType" component={ExamTypeSelector} t={t} />
          </div>
        </div>
        <div className="form__form-group--3_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('communication.evaluationWay')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="evaluationWay"
                type="text"
                component={Select}
                isDisabled={!evaluationWayList || !editable}
                options={evaluationWayList}
                placeholder={t('communication.placeholders.evaluationWay')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('communication.evaluationType')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="evaluationType"
                type="text"
                component={Select}
                isDisabled={!evaluationTypes || !editable}
                options={evaluationTypes}
                placeholder={t('communication.placeholders.evaluationType')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('communication.weight')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="weight"
                type="number"
                component={renderField}
                isDisabled={!editable}
                min="1"
                placeholder={t('communication.placeholders.weight')}
              />
            </div>
          </div>
        </div>
      </FormSection>
      <div className="form__form-group">
        <span className="form__form-group-label">{t('general.subject')}</span>
        <div className="form__form-group-field">
          <Field
            name="title"
            type="text"
            component={renderField}
            placeholder={t('communication.placeholders.exam-title')}
            maxLength="250"
            readOnly={!editable}
          />
        </div>
      </div>
    </Fragment>
  );
};

ExamFields.propTypes = {
  t: PropTypes.func.isRequired,
  showLoading: PropTypes.func.isRequired,
  hideLoading: PropTypes.func.isRequired,
  loadCourseSteps: PropTypes.func.isRequired,
  loadSubjects: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  listOfCourseStep: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  recipients: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  subjects: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  evaluationTypes: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  cycles: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  loadCourseStepsChangeHandler: PropTypes.func.isRequired,
};

export default withTranslation('common')(ExamFields);
